import React, { createContext, ReactNode, useCallback, useContext, useMemo, useState } from 'react';
import type { Intent, UseCaseId } from '../types/content';
interface EnquiryState {
  useCase: UseCaseId | '';
  intent: Intent;
  setUseCase: (useCase: UseCaseId) => void;
  startEnquiry: (options: {
    useCase?: UseCaseId;
    intent?: Intent;
  }) => void;
  selectIndustry: (useCase: Exclude<UseCaseId, 'other'>) => void;
  setActiveIndustry: (useCase: Exclude<UseCaseId, 'other'>) => void;
  activeIndustry: Exclude<UseCaseId, 'other'>;
}
const EnquiryContext = createContext<EnquiryState | null>(null);
export function EnquiryProvider({
  children
}: {
  children: ReactNode;
}) {
  const [useCase, setUseCase] = useState<UseCaseId | ''>('');
  const [intent, setIntent] = useState<Intent>('assessment');
  const [activeIndustry, setActiveIndustry] = useState<Exclude<UseCaseId, 'other'>>('remote');
  const scrollTo = (id: string) => {
    document.getElementById(id)?.scrollIntoView({
      behavior: 'smooth',
      block: 'start'
    });
  };
  const startEnquiry = useCallback((options: {
    useCase?: UseCaseId;
    intent?: Intent;
  }) => {
    if (options.useCase) setUseCase(options.useCase);
    setIntent(options.intent ?? 'assessment');
    scrollTo('contact');
  }, []);
  const selectIndustry = useCallback((id: Exclude<UseCaseId, 'other'>) => {
    setActiveIndustry(id);
    setUseCase(id);
    scrollTo('industries');
  }, []);
  const value = useMemo(() => ({
    useCase,
    intent,
    setUseCase,
    startEnquiry,
    selectIndustry,
    setActiveIndustry,
    activeIndustry
  }), [useCase, intent, startEnquiry, selectIndustry, activeIndustry]);
  return <EnquiryContext.Provider value={value} data-id="element-563" data-mp="3s48uf7rh4uuh">{children}</EnquiryContext.Provider>;
}
export function useEnquiry() {
  const context = useContext(EnquiryContext);
  if (!context) throw new Error('useEnquiry must be used within EnquiryProvider');
  return context;
}